import { addProductToCart } from './llukes-product.js';

document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!form.matches('[data-cross-sell-form]')) return;
  event.preventDefault();
  if (form.dataset.pending === 'true') return;
  const variant = form.querySelector('select[name="id"]');
  if (!variant?.value) {
    variant?.reportValidity();
    return;
  }

  const button = form.querySelector('button[type="submit"]');
  const errorMessage = form.querySelector('[data-cross-sell-error]');
  const cartCheck = form.querySelector('[data-cross-sell-cart-check]');
  const originalText = button.textContent;
  form.dataset.pending = 'true';
  form.setAttribute('aria-busy', 'true');
  button.disabled = true;
  button.textContent = window.llukesStrings.adding;
  errorMessage.hidden = true;
  errorMessage.textContent = '';
  cartCheck.hidden = true;

  try {
    await addProductToCart(form.dataset.addUrl, variant.value);
    form.closest('[data-cross-sell]').hidden = true;
    document.dispatchEvent(new CustomEvent('llukes:cart-updated', { detail: { open: true } }));
  } catch (error) {
    errorMessage.textContent = error.status === 422
      ? window.llukesStrings.stock_error
      : error.status && error.status < 500
        ? window.llukesStrings.add_refused
        : window.llukesStrings.add_uncertain;
    errorMessage.hidden = false;
    cartCheck.hidden = error.status === 422 || (error.status && error.status < 500);
  } finally {
    form.dataset.pending = 'false';
    form.removeAttribute('aria-busy');
    button.disabled = false;
    button.textContent = originalText;
  }
});
